/* No2moro custom-section size dropdowns: show one regional twin per size.
 * Do not touch native PDP variant pickers, app-provided selects or checkout.
 */
(() => {
  const selector=[
    '.no2-ae-look-product__variant',
    '.no2-autumn-product__variant',
    '.no2-edit-foundation-product__variant',
    '.no2-edit-shop-card__variant',
    '.product-bundle-card__option select[name="id"]'
  ].join(',');
  const marker=String.fromCodePoint(0x2060);
  const isUK=String(window.No2moroRegionalPricingConfig?.country ||
    window.Shopify?.country||'').toUpperCase()==='GB';
  const useGB=()=>isUK && String(window.No2moroGeoRegion||'').toLowerCase()!=='ni';
  const originals=new WeakMap();
  const strip=x=>String(x||'').split(marker).join('');
  const hasTwins=opts=>opts.some(o=>o.textContent.includes(marker)) &&
    opts.some(o=>!o.textContent.includes(marker));
  let applying=false;
  function syncSelect(select) {
    if(!select?.isConnected)return;
    const now=[...select.options];
    let source=originals.get(select);
    // A colour/product-change handler may replace all options with new variants.
    if(!source || now.some(o=>!source.some(x=>x.value===o.value))) {
      if(!hasTwins(now)){originals.delete(select);return;}
      source=now.map(o=>o.cloneNode(true));
      originals.set(select,source);
    }
    if(!source || !hasTwins(source))return;
    const desired=useGB();
    const options=source.filter(o=>o.textContent.includes(marker)===desired);
    if(!options.length)return;
    const old=select.selectedOptions[0];
    const previous=strip(old?.textContent).replace(/\s*(?:-|—)\s*Sold out$/i,'').trim();
    const selected=options.find(o=>!o.disabled &&
      strip(o.textContent).replace(/\s*(?:-|—)\s*Sold out$/i,'').trim()===previous
    ) || options.find(o=>!o.disabled) || options[0];
    const identical=now.length===options.length &&
      now.every((o,i)=>o.value===options[i].value);
    if(!identical) {
      const oldValue=select.value;
      applying=true;
      try{
        select.replaceChildren(...options.map(o=>{
          const clone=o.cloneNode(true);
          clone.textContent=strip(clone.textContent);
          return clone;
        }));
        select.value=selected.value;
      } finally {applying=false;}
      if(select.value!==oldValue)select.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
  function sync(root=document) {
    if(!root?.querySelectorAll)return;
    if(root.matches?.(selector))syncSelect(root);
    root.querySelectorAll(selector).forEach(syncSelect);
  }
  let queued=false;
  function queue() {
    if(queued||applying)return;
    queued=true;
    requestAnimationFrame(()=>{queued=false;sync(document);});
  }
  function start() {
    sync(document);
    const observer=new MutationObserver(mutations=>{
      if(applying)return;
      if(mutations.some(m=>m.addedNodes?.length||m.removedNodes?.length))queue();
    });
    observer.observe(document.body,{childList:true,subtree:true});
    window.addEventListener('no2moro:pricing-region-change',queue);
    window.addEventListener('no2moro:pricing-region-applied',queue);
    let last=String(window.No2moroGeoRegion||'');
    const began=Date.now();
    const watch=setInterval(()=>{
      const geo=String(window.No2moroGeoRegion||'');
      if(geo!==last){last=geo;queue();}
      if(Date.now()-began>15000)clearInterval(watch);
    },250);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
